import { createRouter, createWebHistory } from '@ionic/vue-router';
import Root from '../views/RootActions.vue';
import Login from '../views/LogIn.vue';
import HomePage from '../views/HomePage.vue';
import Incoming from '../views/IncomingItems.vue';
import Outgoing from '../views/OutgoingItems.vue';
import Movement from '../views/MoveItems.vue';
import SelectProject from '../views/SelectProject.vue';
import ManageProject from '../views/ManageProject.vue';
import SelectProjectForPackages from '../views/SelectProjectForPackages.vue';
import ManagePackages from '../views/ManagePackages.vue';
import SelectBaseOrder from '../views/SelectBaseOrder.vue';
import ManageBaseOrder from '../views/ManageBaseOrder.vue';
import SelectAdvancedOrder from '../views/SelectAdvancedOrder.vue';
import ManageAdvancedOrder from '../views/ManageAdvancedOrder.vue';
import SelectInventory from '../views/SelectInventory.vue';
import SelectInventoryDocument from '../views/SelectInventoryDocument.vue';
import ManageListInventory from '../views/ManageListInventory.vue';
import ManageFreeInventory from '../views/ManageFreeInventory.vue';
import ManageMixedInventory from '../views/ManageMixedInventory.vue';
import SelectPickingLists from '../views/SelectPickingLists.vue';
import ManagePickingLists from '../views/ManagePickingLists.vue';
import SelectStoreSupply from '../views/SelectStoreSupply.vue';
import ManageStoreSupply from '../views/ManageStoreSupply.vue';
import PrintPriceLabel from '../views/PrintPriceLabel.vue';

const routes = [
	{
		path: '/',
		name: 'Root',
		component: Root,
	},
	{
		path: '/login',
		name: 'LogIn',
		component: Login,
	},
	{
		path: '/home',
		name: 'Home',
		component: HomePage
	},
	{
		path: '/incoming',
		name: 'IncomingItems',
		component: Incoming
	},
	{
		path: '/incoming/:id',
		name: 'IncomingItemsId',
		component: Incoming,
	},
	{
		path: '/outgoing',
		name: 'OutgoingItems',
		component: Outgoing
	},
	{
		path: '/outgoing/:id',
		name: 'OutgoingItemsId',
		component: Outgoing
	},
	{
		path: '/movement',
		name: 'MoveItems',
		component: Movement
	},
	{
		path: '/project/selection',
		name: 'SelectProject',
		component: SelectProject
	},
	{
		path: '/project/management/:id',
		name: 'ManageProjectId',
		component: ManageProject
	},
	{
		path: '/package/selection',
		name: 'SelectProjectForPackages',
		component: SelectProjectForPackages
	},
	{
		path: '/package/management/:id',
		name: 'ManagePackages',
		component: ManagePackages
	},
	{
		path: '/order/base/selection',
		name: 'SelectBaseOrder',
		component: SelectBaseOrder
	},
	{
		path: '/order/base/management/:id',
		name: 'ManageBaseOrderId',
		component: ManageBaseOrder
	},
	{
		path: '/order/advanced/selection',
		name: 'SelectAdvancedOrder',
		component: SelectAdvancedOrder
	},
	{
		path: '/order/advanced/management/:id',
		name: 'ManageAdvancedOrderId',
		component: ManageAdvancedOrder
	},
	{
		path: '/inventory/selection',
		name: 'SelectInventory',
		component: SelectInventory
	},
	{
		path: '/inventory/selection/:id',
		name: 'SelectInventoryDocument',
		component: SelectInventoryDocument
	},
	{
		path: '/inventory/list_management/:id',
		name: 'ManageListInventory',
		component: ManageListInventory
	},
	{
		path: '/inventory/free_management/:id',
		name: 'ManageFreeInventory',
		component: ManageFreeInventory
	},
	{
		path: '/inventory/mixed_management/:id',
		name: 'ManageMixedInventory',
		component: ManageMixedInventory
	},
	{
		path: '/picking/selection',
		name: 'SelectPickingLists',
		component: SelectPickingLists
	},
	{
		path: '/picking/management',
		name: 'ManagePickingLists',
		component: ManagePickingLists
	},
	{
		path: '/store/selection',
		name: 'SelectStoreSupply',
		component: SelectStoreSupply
	},
	{
		path: '/store/management/:id',
		name: 'ManageStoreSupplyId',
		component: ManageStoreSupply
	},
	{
		path: '/print/price_label',
		name: 'PrintPriceLabel',
		component: PrintPriceLabel
	},
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
